// USA central point
export const MAP_DEFAULTS = {
  center: {
    latitude: 39.50,
    longitude: -98.35
  },
  zoom: 4
}
